import React from 'react';

import { Stack, Typography } from '@mui/material';

import { useAllVaultData } from '~components/hooks/protocol/vaults/useAllVaultData';
import { primaryColors, secondaryColors } from '~components/theme/styles/colors';
import { secondaryBox } from '~components/theme/styles/mixins';
import { EDisplayType } from '~components/types';
import { displayFormatUnits } from '~components/utils/utils';

import { CollateralizationGraph } from '../../statistics/graphs/collateralizationGraph';
import SlideWrapper from '../SlideWrapper';

function VstCollateralizationSlide() {
  const {
    computed: { totalCollateralUsd, totalSystemDebtVst },
  } = useAllVaultData();

  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <Stack spacing={4} mb={4} textAlign={{ xs: 'center', sm: 'left' }}>
        <Typography variant={'h4'}>VST is an over-collateralized stablecoin</Typography>
        <Typography variant={'body1'} color={primaryColors[400]}>
          At Vesta we believe in decentralization, so VST has 0 direct centralized stablecoins as collateral
          and we are not planning to add any.
        </Typography>
      </Stack>
      <Stack direction={{ xs: 'column-reverse', sm: 'column' }} spacing={4} pb={{ xs: 58, sm: 0 }}>
        <CollateralizationGraph />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
          <Stack sx={secondaryBox} width={'100%'}>
            <Typography variant={'h6'} color={primaryColors[700]}>
              Total Value Locked
            </Typography>
            <Typography variant={'h6'} color={primaryColors[100]}>
              {displayFormatUnits({ value: totalCollateralUsd, displayType: EDisplayType.USD })}
            </Typography>
          </Stack>
          <Stack sx={secondaryBox} width={'100%'}>
            <Typography variant={'h6'} color={primaryColors[700]}>
              Collateralization Ratio
            </Typography>
            <Typography variant={'h6'} color={primaryColors[100]}>
              1 VST backed by{' '}
              <Typography component={'span'} variant={'h6'} color={secondaryColors[200]}>
                {' '}
                {displayFormatUnits({
                  value: totalCollateralUsd / totalSystemDebtVst,
                  displayType: EDisplayType.USD,
                })}
              </Typography>
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </SlideWrapper>
  );
}

export default VstCollateralizationSlide;
